const fitMapToBounds = (map, bounds, padding = 20, maintainZoomLevel, zoomOutByDefault) => {
  const options = { duration: 0, padding };
  // Fit map to bounds if bounds are valid
  if (!bounds.isEmpty()) {
    // use cameraForBounds to keep zoom level when adding waypoints
    if (maintainZoomLevel) {
      map.cameraForBounds(bounds, options);
    } else {
      map.fitBounds(bounds, options);
    }
  } else {
    if (zoomOutByDefault) {
      map.setZoom(0);
    }
  }
};

export { fitMapToBounds };
